import { WorkOrderState } from './work-order-state';

export class DashboardWorkOrderGraphData {
  key: WorkOrderState;
  value: number;
  data: any[];
  color?: string;
  label?: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    if (this.key === WorkOrderState.Pending) {
      this.label = 'Pending Approval';
    } else if (this.key === WorkOrderState.Approved) {
      this.label = 'Pending Release';
    } else {
      this.label = this.key;
    }

    return this;
  }
};
